import React, { Component } from 'react'

export default class Landing extends Component {
    render() {
        return (
            <div>
                cfgcggvhnvhn
            </div>
        )
    }
}
